export const GenerateID = (name: string) => {
  const lowerCaseRegex = name.toLocaleLowerCase().replace(/\s/g, "");
  return lowerCaseRegex;
};
